var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 98,
    viewBox: "0 0 86 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9635 40.4057L86 35.2385H52.5213L65.1254 14.0759C73.8087 16.3592 80.4817 23.6027 81.9158 32.5748H85.727C84.3154 22.1988 76.9189 13.7333 67.1168 10.7349L73.5117 0H65.1859L59.4727 9.56136C59.4138 9.56136 59.3549 9.55332 59.2968 9.55332C45.778 9.55332 34.6333 19.5796 32.8678 32.575H36.6782C38.31 22.3614 46.7262 14.3722 57.1726 13.4095L44.1256 35.2371H32.5942L33.6307 40.4043H41.0345L38.7881 44.1633H34.3832L35.2011 48.235H36.3553L19.4115 76.5829H5.6556C2.54603 76.5829 0.00120992 78.8741 0.00120992 81.6729V87.1747H49.481V82.2214H76.577L82.6395 51.9938L42.5385 51.9946L44.7786 48.2356H83.3927L84.209 44.1639H47.2034L49.4435 40.4049L84.9635 40.4057ZM40.8876 76.5812H27.8913L37.6143 60.261L40.8876 76.5812Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 88.4071H3.84841V98H0V88.4071Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6309 88.4071H49.4793V98H45.6309V88.4071Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1119 88.4071H42.9603V98H39.1119V88.4071Z",
    fill: "#FF5910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5946 88.4071H36.443V98H32.5946V88.4071Z",
    fill: "#FF5910"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0756 88.4071H29.924V98H26.0756V88.4071Z",
    fill: "#FF5910"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5565 88.4071H23.4049V98H19.5565V88.4071Z",
    fill: "#FF5910"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0375 88.4071H16.8859V98H13.0375V88.4071Z",
    fill: "#FF5910"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51904 88.4071H10.3675V98H6.51904V88.4071Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsIcon2);
export default __webpack_public_path__ + "static/media/OperationsIcon2.86c2565ef89bf100aef397bf74b92535.svg";
export { ForwardRef as ReactComponent };